import { Component, forwardRef, HostBinding, Input } from '@angular/core'
import { FormControlValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms'
import { LocaleService } from 'framework/locale/services/locale.service'

let _uniqueIdCounter = 0

@Component({
    selector: 'mg-configurator-checkbox',
    templateUrl: './configurator-checkbox.component.html',
    styleUrls: ['./configurator-checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfiguratorCheckboxComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfiguratorCheckboxComponent),
            multi: true,
        },
    ],
})
export class ConfiguratorCheckboxComponent extends FormControlValueAccessor {
    @Input()
    checkedValue: any

    @Input()
    uncheckedValue: any = null

    @Input()
    isDisabled: boolean = false

    @Input()
    label: string = ''

    @Input()
    optionName: string = ''

    @Input()
    description: string = ''

    @Input()
    modalKeys: string[] = []

    @Input()
    @HostBinding('class._is_small')
    small: boolean = false

    labelId: string = `configurator-checkbox-label-${_uniqueIdCounter++}`

    language: string

    constructor(private localeService: LocaleService) {
        super()
    }

    get isChecked() {
        return this.value === this.checkedValue
    }

    toggleValue() {
        this.value = this.isChecked ? this.uncheckedValue : this.checkedValue
    }

    onCheckboxClick(event) {
        event.preventDefault()
        this.toggleValue()
    }

    async validate(): Promise<ValidationErrors | null> {
        return [this.checkedValue, this.uncheckedValue].indexOf(this.value) !== -1 ? null : { value: 'no value set' }
    }
}
